import React from 'react';
import { Modal, Button } from 'semantic-ui-react';
import styled from 'styled-components';
import { StyledModal } from './SharedStyles';

const sizeLabels = { 1: 'Small', 2: 'Medium', 3: 'Large' };

const DetailRow = styled.div`
  margin-bottom: 1em;
`;

const DetailLabel = styled.div`
  font-size: 0.85em;
  color: #888;
  margin-bottom: 0.25em;
`;

const DetailValue = styled.div`
  font-size: 1em;
  color: #333;
  word-break: break-word;
`;

const TaskDetailView = ({ open, task, onClose }) => {
  if (!task) return null;

  const dueDate = task.due ? new Date(task.due) : null;
  const isValidDate = dueDate && !isNaN(dueDate.getTime()) && dueDate.getFullYear() > 1970;

  return (
    <StyledModal open={open} onClose={onClose} size="small">
      <Modal.Header>Task Details</Modal.Header>
      <Modal.Content>
        <DetailRow>
          <DetailLabel>Label</DetailLabel>
          <DetailValue>{task.label || '—'}</DetailValue>
        </DetailRow>
        {task.content && (
          <DetailRow>
            <DetailLabel>Content</DetailLabel>
            <DetailValue>{task.content}</DetailValue>
          </DetailRow>
        )}
        {task.url && (
          <DetailRow>
            <DetailLabel>URL</DetailLabel>
            <DetailValue>
              <a href={task.url} target="_blank" rel="noopener noreferrer">{task.url}</a>
            </DetailValue>
          </DetailRow>
        )}
        {isValidDate && (
          <DetailRow>
            <DetailLabel>Due Date</DetailLabel>
            <DetailValue>{dueDate.toLocaleDateString()}</DetailValue>
          </DetailRow>
        )}
        {task.size > 0 && (
          <DetailRow>
            <DetailLabel>Size</DetailLabel>
            <DetailValue>{sizeLabels[task.size] || task.size}</DetailValue>
          </DetailRow>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>OK</Button>
      </Modal.Actions>
    </StyledModal>
  );
};

export default TaskDetailView;
